// Testknopf fuer den Abgleich der Vertragsvorlagen mit dem Wissensdienst.
//
// Anders als die Klingel beim Speichern WARTET dieser Knopf auf das Ergebnis:
// Er sagt, wie viele Vorlagen geprueft, wie viele Abschnitte neu eingebettet
// wurden und ob etwas scheiterte. Dient zugleich als "jetzt abgleichen", falls
// eine Klingel verloren ging - jeder Abgleich prueft ALLE Vorlagen.

import React, { useState } from 'react';
import axios from 'axios';
import { RefreshCw } from 'lucide-react';
import { T, knopfStil, ueberzeileStil } from '../../lib/designTokens';

export default function VorlagenAbgleichTest({ apiBase = '/api', session = null, onFertig = null }) {
  const [laeuft, setLaeuft] = useState(false);
  const [ergebnis, setErgebnis] = useState(null);

  const starten = async () => {
    setLaeuft(true);
    setErgebnis(null);
    try {
      const token = session?.access_token;
      const antwort = await axios.post(
        `${apiBase}/contracts/state?resource=vorlagen-abgleich`,
        {},
        // Seit der KI-Einordnung kann der erste Lauf mehrere Minuten dauern;
        // der Server darf 300 s laufen.
        { headers: token ? { Authorization: `Bearer ${token}` } : {}, timeout: 290000 },
      );
      const fehler = [...(antwort.data?.ergebnis?.fehler || []), ...(antwort.data?.einordnung?.fehler || [])];
      setErgebnis({ ok: true, text: antwort.data?.text || 'Abgleich abgeschlossen.', fehler });
    } catch (error) {
      const d = error?.response?.data || {};
      const fehler = [...(d.ergebnis?.fehler || []), ...(d.einordnung?.fehler || [])];
      setErgebnis({ ok: false, text: d.text || d.detail || d.grund || error.message || 'Abgleich fehlgeschlagen.', fehler });
    } finally {
      setLaeuft(false);
      if (onFertig) onFertig();
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ fontSize: T.tMeta, color: T.body, lineHeight: 1.6 }}>
        Trägt fehlende KI-Einordnungen nach, stößt dann den Abgleich an und wartet
        auf das Ergebnis. Beim ersten Mal schreibt die KI alle Einordnungen — das
        dauert einige Minuten; bleiben welche offen, einfach noch einmal drücken.
        Danach geht es in Sekunden — eingebettet wird nur, was sich geändert hat.
      </div>
      <button type="button" onClick={starten} disabled={laeuft}
        style={{ ...knopfStil(true), alignSelf: 'flex-start', opacity: laeuft ? 0.6 : 1 }}>
        <RefreshCw size={13} style={laeuft ? { animation: 'spin 1s linear infinite' } : undefined} />
        {laeuft ? 'Gleicht ab …' : 'Jetzt abgleichen'}
      </button>
      {ergebnis ? (
        <div style={{
          border: `1px solid ${ergebnis.ok && !ergebnis.fehler.length ? T.gutRand : T.gefahrRand}`,
          background: ergebnis.ok && !ergebnis.fehler.length ? T.gutGrund : T.gefahrGrund,
          color: ergebnis.ok && !ergebnis.fehler.length ? T.gut : T.gefahr,
          borderRadius: T.rChip, padding: '9px 11px', fontSize: T.tMeta, lineHeight: 1.55,
        }}>
          {ergebnis.text}
          {ergebnis.fehler.length ? (
            <div style={{ marginTop: 6 }}>
              <div style={{ ...ueberzeileStil, color: T.gefahr, marginBottom: 3 }}>Fehler</div>
              {ergebnis.fehler.map((f) => <div key={f}>{f}</div>)}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
